export default __webpack_public_path__ + "static/media/emoji_like.69f6d284.png";